import { mapGetters } from 'vuex';
import { gql } from 'graphql-request';
import { getTokenService } from '@/services/token';

const pickToken = () => getTokenService().getAccessToken();

export default {
  data() {
    return {
      userAppDataNames: [
        'preventionPersonalizationEnabled',
        'preventionListSettings',
        'authorization_modal_shown',
        'feedbackOpenAt',
        'nonPublishingBannerHidden',
        'latestThematicTestDone'
      ]
    };
  },
  computed: {
    ...mapGetters({
      userAppData: 'profile/userAppData/userAppData'
    })
  },
  methods: {
    appSettingsHeaders(forceAuthorization = false) {
      const token = pickToken();
      const sendAuth = this.$store?.state?.general?.sendAuthorizationHeader !== false;

      if (!token) {
        return {};
      }

      if (!sendAuth && !forceAuthorization) {
        return {};
      }

      return {
        authorization: `Bearer ${token}`
      };
    },

    async updateUserAppData(payload, forceAuthorization = false) {
      const mutation = gql`
        mutation setUserAppData($name: String!, $value: String!) {
          setUserAppData(name: $name, value: $value)
        }
      `;

      const variables = {
        name: payload.name,
        value: payload.value.toString()
      };

      try {
        await this.$graphql.appSettings.request(
          mutation,
          variables,
          this.appSettingsHeaders(forceAuthorization)
        );
      } catch (err) {
        this.handleError({ error: err, code: '0x00000045' });
      }
    },

    async deleteUserAppData(name) {
      const mutation = gql`
        mutation deleteUserAppData($name: String!) {
          deleteUserAppData(name: $name)
        }
      `;

      try {
        await this.$graphql.appSettings.request(mutation, { name }, this.appSettingsHeaders(false));
      } catch (err) {
        this.handleError({ error: err, code: '0x00000046' });
      }
    },

    async getUserAppData() {
      try {
        const query = gql`
          query getUserAppData($names: [String!]!) {
            getUserAppData(names: $names) {
              name
              value
            }
          }
        `;

        const variables = {
          names: this.userAppDataNames
        };

        const data = await this.$graphql.appSettings.request(
          query,
          variables,
          this.appSettingsHeaders(false)
        );

        if (data) {
          await this.$store.dispatch('profile/userAppData/setUserAppData', data.getUserAppData);
          await this.$store.dispatch('profile/userAppData/setLoadingAppData', false);
        }
      } catch (err) {
        this.handleError({ error: err, code: '0x00000047' });
      }
    }
  }
};
